module.exports = __webpack_public_path__ + "static/tp-feature-2-6769ec99d26b7c55dd85d448f2a7e6ac.png";